<template>
<div class="modal tw-p-0" role="dialog" id="modal">
    <portal-target :name="source"></portal-target>
</div>
</template>

<script>
export default {
    name: "BaseModal",

    data() {
        return {
            source: ''    
        }
    },

    mounted() {
        EventBus.$on('modal-custom', event => {
            this.source = event.name;
            
            $('#modal').modal({
                backdrop: 'static'
            });
        });

        EventBus.$on('modal-loaded', () => {
            this.$nextTick(() => {
                $('[data-toggle="tooltip"]').tooltip();
            });
        });

        $('#modal').on('hidden.bs.modal', () => {
            EventBus.$emit('modal-closed');
        });

        $('#modal').on('shown.bs.modal', () => {
            EventBus.$emit('modal-ready');
        });
    }
}
</script>

<style>

</style>